import { defineComponent as _defineComponent } from 'vue'

import { useI18n } from 'vue-i18n'
import { soundIsPlaying, stopSounds } from '@/utilities'
import Button from '@/components/base/Button.vue'
import omarGlad from '@/assets/omar/OMAR-GLAD.svg'
import omarChat from '@/assets/omar/omar_chat1.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'Instruction',
  props: {
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  image: {
    type: String,
    default: '',
  },
  imageHeight: {
    type: String,
    default: '300px',
  },
  speakerTop: {
    type: String,
    default: '2rem',
  },
  speakerRight: {
    type: String,
    default: '3rem',
  },
  discussion: {
    type: String,
    default: '',
  },
},
  emits: ['playsound', 'stopsound'],
  setup(__props, { expose }) {
  expose();

const messages = {
  no: {
    snakkeSammen: 'snakk sammen',
  },
  en: {
    snakkeSammen: 'discuss together',
  },
}
const { t } = useI18n({ messages })




const __returned__ = { messages, t, soundIsPlaying, stopSounds, Button, omarGlad, omarChat }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})